export const components = {
  Close: 'Fechar',
  "Hello, I'd like to talk with someone at the {{unit}} clinic":
    'Olá, eu gostaria de conversar com alguém da unidade {{unit}}',
  'Mon to Fri': 'Seg a Sex',
  Sat: 'Sáb',
  'Service hours': 'Horários de Atendimento',
  '{{start}} until {{end}}': '{{start}} às {{end}}',
  '{{street}}, N {{number}} - {{district}}':
    '{{street}}, nº{{number}} - {{district}}',
  Sun: 'Dom',
  'Talk to the clinic': 'Falar com a clínica',
  'Unit information': 'Informações da unidade',
  'See more details': 'Ver mais detalhes',
};
